/* Copyright 2019 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "mw-form/mixins/property/ShortcutMixin"
], function (declare, TextMixin, TextOverrideMixin, DescriptionMixin, DescriptionOverrideMixin, ShortcutMixin) {
    var TooltipMixin = declare(null, {
        /** @lends TooltipMixin# */

        /**
         * It should be mixed in by any component that wants a tooltip to be attached to it.
         * @class
         */

        _setDescriptionAttr: function () {
            this.inherited(arguments);
            this._updateTooltip();
        },

        _setTextAttr: function () {
            this.inherited(arguments);
            this._updateTooltip();
        },

        _setShortcutAttr: function (value) {
            this._set("shortcut", value);
            this._updateTooltip();
        },

        /* Override for DescriptionMixin, ShortcutMixin and TextMixin */
        _updateTitle: function () {
            this._updateTooltip();
        },

        _updateTooltip: function () {
            var tooltipLabel = "",
                tooltipShortcut = "",
                tooltipDescription = "";

            if (this._excludeTextInTooltip) {
                tooltipLabel = "";
            } else if (this.textOverride) {
                tooltipLabel = this.textOverride;
            } else if (this.text) {
                tooltipLabel = this.text;
            }

            if (this._excludeShortcutInTooltip) {
                tooltipShortcut = "";
            } else if (this.shortcut) {
                tooltipShortcut = this._getPlatformizedShortcut(this.shortcut);
            }

            if (this._excludeDescriptionInTooltip) {
                tooltipDescription = "";
            } else if (this.descriptionOverride) {
                tooltipDescription = this.descriptionOverride;
            } else if (this.description) {
                tooltipDescription = this.description;
            }

            this._updateTooltipLayout(tooltipLabel, tooltipShortcut, tooltipDescription);
        },
        
        _updateTooltipLayout: function (tooltipLabel, tooltipShortcut, tooltipDescription) {
            var firstBuffer = "",
                secondBuffer = "";
            
            if (tooltipLabel) {
                if (tooltipShortcut) {
                    firstBuffer = " (";
                    secondBuffer = ")";
                    tooltipLabel = tooltipLabel.replace(/\n/g, " ");
                }
                if (tooltipDescription) {
                    secondBuffer += " - ";
                    tooltipDescription = tooltipDescription.replace(/\n/g, " ");
                }
            } else if (tooltipShortcut && tooltipDescription) {
                // To maintain backward consistency, we flip the order of description
                // and shortcut if they are the only two parts of the tooltip.
            
                tooltipLabel = tooltipDescription.replace(/\n/g, " ");
                tooltipDescription = "";
                firstBuffer = " (";
                secondBuffer = ")";
            }

            this._updateTitleInDOM(tooltipLabel + firstBuffer + tooltipShortcut + secondBuffer + tooltipDescription);
        },

        _updateTitleInDOM: function (title) {
            var titleNodes = this.getTitleNodes();
            titleNodes.forEach(function(node) {
                node.setAttribute("title", title);
            });
        },

        /**
         * Get the array of title nodes.
         * @returns {Array}
         */
        getTitleNodes: function() {
            return [this.domNode];
        }
    });

    TooltipMixin._dependencies = [
        {mixin: TextMixin, orderDependent: true},
        {mixin: TextOverrideMixin, orderDependent: true},
        {mixin: DescriptionMixin, orderDependent: true},
        {mixin: DescriptionOverrideMixin, orderDependent: true},
        {mixin: ShortcutMixin, orderDependent: true}
    ];

    return TooltipMixin;
});

